import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './slices/apiSlice';
import cartReducer from './slices/cartSlice';
import authReducer from './slices/authSlice';

// ✅ Hydrate cart correctly from localStorage
const cartFromStorage = localStorage.getItem('cart')
  ? JSON.parse(localStorage.getItem('cart'))
  : {
      cartItems: [],
      shippingAddress: {},
      paymentMethod: '', // or skip if not used
    };

const initialState = {
  cart: cartFromStorage, // ✅ FIXED: this passes full cart object, not just cartItems
  // auth: { userInfo: userInfoFromStorage },
};

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    cart: cartReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
  preloadedState: initialState,
});

export default store;
